import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/gen-t-icon.png'


const _hoisted_1 = { class: "hero-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    cols: "4",
    sm: "4",
    md: "3",
    class: "ml-auto"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "b-img-lazy",
      src: _imports_0,
      alt: "Logo Projeto Gen-t",
      fluid: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    cols: "8",
    md: "6",
    class: "p-0 text-center mr-md-auto"
  }, [
    /*#__PURE__*/_createElementVNode("p", {
      class: "font-weight-bolder mb-3",
      style: {"font-size":"3em"}
    }, "Obrigado!"),
    /*#__PURE__*/_createElementVNode("p", { class: "lead" }, "Sua resposta foi registrada com sucesso."),
    /*#__PURE__*/_createElementVNode("p", { class: "font-weight-bolder mb-0" }, " Abaixo disponibilizamos um link para que você possa preencher nosso questionário base de saúde, caso deseje. ")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  cols: "12",
  sm: "8",
  class: "mx-auto"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Questionário Base de Sáude ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Preencher ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_icon = _resolveComponent("b-icon")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_card_body = _resolveComponent("b-card-body")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_b_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_card_body, { class: "d-flex flex-row align-items-center justify-content-between p-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_icon, {
                  icon: "file-text-fill",
                  variant: "orange",
                  "font-scale": "1.75"
                }),
                _createVNode(_component_b_card_text, { class: "mb-0" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_link, { to: "questionario-base-de-saude" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_icon, { icon: "pencil-square" }),
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}